<template>
  <div class="detail-tips">
    <div class="cate-list">
      <div class="cate-item" v-for="cate in detail.cate_tips">
        <h2>{{ cate.cate_name }}</h2>
        <div class="tips-list">
          <div class="tips-item" v-for="tip in cate.tips">
            <div class="tips-image">
              <img :src="tip.image" alt="" loading="lazy">
            </div>
            <div class="tips-container">
              <div class="tips-title">
                <p>Model</p>
                <h3>{{ tip.name }}</h3>
              </div>
              <div class="tips-content">
                <p v-html="tip.content"></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "detail-tips",
  props: {
    detail: {
      type: Object,
      default: {}
    }
  },
  data(){
    return {

    }
  },
  methods: {

  }
}

</script>

<style scoped>
.detail-tips{
  padding: 0 .3rem .8rem .3rem;
}

.detail-tips .cate-list {

}
.detail-tips .cate-list .cate-item {
  margin-top: 2rem;
}
.detail-tips .cate-list .cate-item:first-child {
  margin-top: 1rem;
}
.detail-tips .cate-list .cate-item h2 {
  font-size: .36rem;
  font-weight: 500;
}
.detail-tips .cate-list .cate-item .tips-image {
  width: 100%;
  box-shadow: 0 2px 4px rgba(0, 0, 0, .3), 0 0 6px rgba(0, 0, 0, .04);
  overflow: hidden;
  border-radius: 8px;
}
.detail-tips .cate-list .cate-item .tips-image img {
  width: 100%;
}
.detail-tips .cate-list .cate-item .tips-container {
}
.detail-tips .cate-list .cate-item .tips-container .tips-title {
  font-size: .28rem;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: .4rem 0 .3rem 0;
  border-bottom: 1px solid #B5B5B5;
}
.detail-tips .cate-list .cate-item .tips-container .tips-title p {
  color: #7D7D7D;
}
.detail-tips .cate-list .cate-item .tips-container .tips-title h3 {
  font-weight: 500;
  margin-left: .23rem;
  color: #1C1B1B;
}

.detail-tips .cate-list .cate-item .tips-container .tips-content {
  color: #7D7D7D;
  font-size: .26rem;
  line-height: 2;
  margin-top: .3rem;
}
.detail-tips .cate-list .cate-item .tips-list .tips-item {
  margin-top: .8rem;
}
</style>

<style>
.detail-tips .cate-list .cate-item .tips-container .tips-content p {
  font-size: .26rem!important;
  white-space: pre-wrap;
}
</style>
